import { Card } from "react-bootstrap";
import { Calendar } from "primereact/calendar";
import styled from "styled-components";

const StyledCardGrey = styled(Card)`
    border: none;
    border-radius: 8px;
    background: rgba(240, 242, 242, 0.5);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
    padding: 0 32px 40px;
`;

const StyledInfoText = styled.div`
    font-weight: 800;
    font-size: 17px;
    line-height: 150%;
    color: #404040;
    left: 140px;
    margin-top: 30px;
`;

const StyledInfoLabel = styled.div`
    font-size: 15px;
    display: flex;
    align-items: center;
    color: #000;
    width: 100%;
`;

const StyledHourContainer = {
    margin: "10px 10px 10px 0",
};

const StyledSmallIcon = {
    height: "12px",
};

const StyledBtnBox = styled.div`
    font-size: 13px;
    border: 1px solid #e4e4e4;
    background-color: #f2f2f2;
    padding: 16px;
    border-radius: 8px;
    height: 48px;
    @media (max-width: 785px) {
        height: auto;
    }
`;

const BtnOutlinePrimarySave = styled.button`
    font-size: 16px;
    border-radius: 24px;
    background-color: #e4e4e4;
    border: none;
    width: 184px;
    color: #404040;
    height: 48px;
    @media (max-width: 785px) {
        margin-top: 20px;
    }
`;

const StyledHourInput = styled.input`
    border-radius: 4px;
    width: 152px;
    border: 1px solid #787878;
    margin: 8px 0;
`;

const StyledMinutesInput = styled.input`
    border-radius: 4px;
    width: 152px;
    border: 1px solid #787878;
    margin: 8px 0;
    ::-webkit-calendar-picker-indicator {
        display: none;
    }
`;

const StyledInputMask = styled(Calendar)`
    border-radius: 4px;
    width: 152px;
    border: 1px solid #787878;
    margin: 8px 0;
`;

export {
    StyledCardGrey,
    StyledInfoText,
    StyledInfoLabel,
    StyledHourContainer,
    StyledHourInput,
    StyledSmallIcon,
    StyledBtnBox,
    BtnOutlinePrimarySave,
    StyledInputMask,
    StyledMinutesInput,
};
